import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Fx, Stack, Layout, Row, Button, Col } from 'Components';
import { useStores } from 'Hooks/useStore';
import { DashboardContext } from 'Pages/Dashboard/DashboardContext';
import DashboardFilters from 'Pages/Dashboard/DashboardFilters/DashboardFilters';
import { DashboardFiltersValues } from 'Pages/Dashboard/Dashboard.types';
import Header from 'PhishingManager/components/Header';
import styles from './Courses.module.scss';
import { DashboardTabKey } from 'Services/Api/Dashboard/Types';
import { MyResultsWidgets } from 'Pages/Dashboard/tabs/MyResults/MyResults.types';
import { OpenInNewTab } from 'Pages/Dashboard/components';

function Courses() {
    const stores = useStores();
    const { systemsStore, authStore } = stores;
    const [filterValues, setFilterValues] = useState<DashboardFiltersValues>({});
    const [hasProperties, setHasProperties] = useState(true);
	const isSuperAdmin = authStore.isCurrentUserSuperAdmin;

    const onFiltersChange = (value: DashboardFiltersValues) => {
        setFilterValues((prev) => ({ ...prev, ...value }));
    };

    useEffect(() => {
        return () => stores.clearDashboardStore();
    }, []);

    return (
        <DashboardContext.Provider value={{ filters: filterValues, hasProperties }}>
            <Fx className={styles.root} fullHeight>
                {/* grow={1} leaves room for a future collapsible sidebar */}
                <Fx column grow={1}>
                    <Stack>
                        <div className={styles.pageHeader}>
                            <Fx align="middle" justify="space-between">
                                <Header title="Courses" description="A quick overview of your assigned training and progress." />
                                {isSuperAdmin && <DashboardFilters onChange={onFiltersChange} onSetHasProperties={setHasProperties} />}
                            </Fx>
                        </div>
                        <Layout>
                        <h1 className={styles.header}>Quick Links</h1>
                            <div className={styles.card}>
                                <h3 className={styles.title}>My Courses</h3>
                                <OpenInNewTab
                                    tab={DashboardTabKey.MyResults}
                                    widget={MyResultsWidgets.MyCourses}
                                    tenantId={isSuperAdmin ? null : systemsStore.selectedTenant.value}
                                    tooltipPlacement="top"
                                    button={(handleButtonClick) => (
                                        <Button
                                            onClick={handleButtonClick}
                                            shape="round"
                                            type="primary"
                                            className={`${styles.btn} cta-prominent`}>Go To My Courses</Button>
                                    )}
                                />
                            </div>
                        </Layout>
                    </Stack>
                </Fx>
            </Fx>
        </DashboardContext.Provider>
    );
}

export default observer(Courses);
